import classnames from 'classnames';
import React from 'react';
import {prefix} from "../../wui-core/src/index";
import { TabContentProps } from './iTabs'
import TabPanel from './TabPane'

const TabContent: React.FC<TabContentProps> = (props) => {
    const {
        activeKey = '',
        children = null,
        items,
        clsPrefix = `${prefix}-tabs`,
        animated = true,
        tabContentClassName,
        style = {},
        destroyInactiveTabPane
    } = props;

    const handleitems = () => {
        let newChildren: any[] = [];
        if (items && items?.length > 0) {
            items?.map(item => {
                const key = item.key;
                const active = activeKey === key;
                newChildren.push(React.cloneElement(<TabPanel style={item?.style} key={item.key} placeholder={item?.placeholder} forceRender={item?.forceRender}>{item.children}</TabPanel>, {
                    active,
                    destroyInactiveTabPane: destroyInactiveTabPane,
                    rootclsPrefix: clsPrefix,
                }));
            })
        } else {
            React.Children.forEach(children, (child: any) => {
                if (!child) {
                    return;
                }
                const key = child.key || '';
                const active = activeKey === key;
                newChildren.push(React.cloneElement(child, {
                    active,
                    destroyInactiveTabPane: destroyInactiveTabPane,
                    rootclsPrefix: clsPrefix,
                    fieldid: undefined,
                    id: undefined
                }));
            });
        }
        return newChildren;
    };

    return (
        <div
            className={classnames(
                `${clsPrefix}-content`,
                animated ? `${clsPrefix}-content-animated` : `${clsPrefix}-content-no-animated`,
                tabContentClassName
            )}
            style={style}
        >
            {handleitems()}
        </div>
    );
};

export default TabContent;
